import { defineMessages } from "react-intl";

const messages = defineMessages({
    solved: {
        id: "share.solved",
    },
    closeRoom: {
        id: "share.closeRoom",
    },
    restartTask: {
        id: "playPlan.restart",
    },
    showSolution: {
        id: "playPlan.showSolution",
    },
    fancyUI: {
        id: "playPlan.fancyUI",
    },
    showScores: {
        id: "playPlan.showScores",
    },
});

export default messages;
